import CustomPopup from "components/Pages/Inbox/Popups/CustomPopup";
import Icon from "components/Elements/Icon/Icon";
import { useContent } from "contexts/contentContext/contentContext";
import { ButtonAccessability } from "components/Elements/Button/Button";

import styles from "./expiresAfterDropdown.module.scss";
import { useUploader } from "contexts/uploaderContext/uploaderContext";
import { useSaveUploadingMail } from "../../Helpers/useSaveUploadingMail";
import { useUser } from "contexts/userContext/userContext";
import { useEffect, useState } from "react";

interface IExpiresAfterDropdown {
  showState: boolean;
  currentValue: number;
}

const ExpiresAfterDropdown = ({
  showState,
  currentValue,
}: IExpiresAfterDropdown) => {
  const { setExpireAfter } = useUploader();
  const { handleClick } = useSaveUploadingMail();
  const { getTextByKey } = useContent();
  const { getUserData } = useUser();
  const [daysArray, setDaysArray] = useState([3, 7]);

  useEffect(() => {
    if (
      getUserData().AutoRemoveDays &&
      ![3, 7].includes(+getUserData().AutoRemoveDays)
    ) {
      setDaysArray([3, 7, getUserData().AutoRemoveDays]);
    }
  }, [getUserData().AutoRemoveDays]);

  return (
    <CustomPopup showState={showState} topPosition={40}>
      <div className={styles.container}>
        <div className={styles.daysWrapper}>
          {daysArray.map((value) => (
            <ButtonAccessability
              key={value}
              onClick={() => setExpireAfter(value)}
              buttonClassName={currentValue === value ? styles.selected : ""}
            >
              {value} {getTextByKey("days")}
            </ButtonAccessability>
          ))}
        </div>
        <ButtonAccessability
          onClick={() => handleClick()}
          buttonClassName={styles.saveButton}
        >
          <Icon name="save" blue />
          {getTextByKey("save-mail-text")}
        </ButtonAccessability>
      </div>
    </CustomPopup>
  );
};

export default ExpiresAfterDropdown;
